import * as React from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { selectUser, UserState } from 'gossamer-front-end';

export const UserButton = (): React.JSX.Element => {
  const user = useSelector((state: { user: UserState }) => selectUser(state));
  if (!user) {
    return <></>;
  }
  return (
    <DropdownButton size="sm" variant="primary" title={'User'}>
      <Dropdown.Item>
        <Link to={`/admin/user/display/${user.userId}`} style={{ textDecoration: 'unset' }}>
          {user.name}
        </Link>
      </Dropdown.Item>
      <Dropdown.Item>
        <Link to="/admin" style={{ textDecoration: 'unset' }}>
          {user.roleId}
        </Link>
      </Dropdown.Item>
      <Dropdown.Item>
        <Link to="/admin/logout" style={{ textDecoration: 'unset' }}>
          Logout
        </Link>
      </Dropdown.Item>
    </DropdownButton>
  );
};
